import { p as l, b as p } from "./trackerReferenceLifecycle-xEM9DpA6.js";
const r = "nimbalyst://view/", k = /^type\/([^/?#\s]+)$/i, m = /^marks(?:\?kind=(decided|open))?$/i;
function $(e) {
  const n = l(e);
  if (n?.kind === "view") return { ...n.view, scope: n.scope };
  if (!e || e.slice(0, r.length).toLowerCase() !== r) return null;
  const t = e.slice(r.length), i = k.exec(t);
  if (i)
    try {
      return { kind: "type", typeId: decodeURIComponent(i[1]) };
    } catch {
      return null;
    }
  const s = m.exec(t);
  return s ? { kind: "marks", marks: s[1]?.toLowerCase() ?? "all" } : null;
}
function u(e, n = e.scope) {
  if (n) {
    const t = e.kind === "type" ? { kind: "type", typeId: e.typeId } : { kind: "marks", marks: e.marks };
    return p({ kind: "view", scope: n, view: t });
  }
  return e.kind === "type" ? `${r}type/${encodeURIComponent(e.typeId)}` : e.marks === "all" ? `${r}marks` : `${r}marks?kind=${e.marks}`;
}
function f(e) {
  const n = e.replace(/\+/g, " ");
  try {
    return decodeURIComponent(n);
  } catch {
    return n;
  }
}
function w(e, n, t = {}, i) {
  const s = n.replace(/[[\]\n]/g, " ").replace(/\s+/g, " ").trim() || "View", c = Object.entries(t).filter(([, o]) => o !== "").map(([o, d]) => `${o}=${d}`).join(" "), a = u(e, i);
  return c ? `[${s}](${a} "${c}")` : `[${s}](${a})`;
}
export {
  w as a,
  u as c,
  f as d,
  $ as p
};
//# sourceMappingURL=placedViewUrl-DrEZQoZ7.js.map
